module.exports = __webpack_public_path__ + "img/illustration-laptop.d08a4a13.svg";